import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { DevPortalTestingAccount } from '../../interfaces/user';
import CopyIcon from '../../assets/icons/Copy';
import LinkIcon from '../../assets/icons/Link';

type PropsType = {
  user: DevPortalTestingAccount;
  onCopy?: () => void;
};

const useStyles = makeStyles(() => ({
  section: {
    marginBottom: '30px',
    minWidth: '564px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',

    '& :first-child': {
      marginRight: '16px',
    },

    '& svg': {
      cursor: 'pointer',
    },
  },
}));

const TestAccountDetails: React.FC<PropsType> = ({ user, onCopy }) => {
  const classes = useStyles();
  const theme = useTheme();

  const onCopyClick = () => {
    const element = document.createElement('textarea');
    element.value = user.password;
    document.body.appendChild(element);
    element.select();
    document.execCommand('copy');
    document.body.removeChild(element);
    onCopy?.();
  };

  return (
    <div>
      <div className={classes.section}>
        <Typography variant="body2">Testing Account Username</Typography>
        <div className={classes.row}>
          <Typography>{user.username}</Typography>
          <a
            href={`https://${user.username}.${user.cluster}/user/login`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkIcon stroke={theme.palette.text.primary} />
          </a>
        </div>
      </div>

      <div>
        <Typography variant="body2">Testing Account Password</Typography>
        <div className={classes.row}>
          <Typography>{user.password}</Typography>
          <div onClick={onCopyClick}>
            <CopyIcon stroke={theme.palette.text.primary} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestAccountDetails;
